"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _styles = require("../../styles");

var _constants = require("../constants");

var _i18n = require("../i18n");

var _validation = require("./validation");

var _core = require("@material-ui/core");

var _client = require("@apollo/client");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _claimAccount = _interopRequireDefault(require("./claimAccount.graphql"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = function styles(theme) {
  var _theme$palette, _theme$palette$enterp, _theme$palette2, _theme$palette2$enter;

  return {
    borrowerVerifyIdentityForm: (0, _defineProperty2["default"])({
      padding: theme.spacing(6)
    }, theme.breakpoints.down('xs'), {
      padding: theme.spacing(5, 2)
    }),
    instructions: {
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(2)
    },
    header: {
      marginBottom: theme.spacing(2)
    },
    submitBtn: {
      '&:disabled': {
        backgroundColor: theme.palette.grey[400],
        color: theme.palette.primary.textContrast,
        fontSize: theme.spacing(3)
      }
    },
    label: {
      '&$focused': {
        color: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$enterp = _theme$palette.enterprise) === null || _theme$palette$enterp === void 0 ? void 0 : _theme$palette$enterp.main
      }
    },
    focused: {},
    outlinedInput: {
      '&$focused $notchedOutline': {
        border: "1px solid ".concat((_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$enter = _theme$palette2.enterprise) === null || _theme$palette2$enter === void 0 ? void 0 : _theme$palette2$enter.main)
      }
    },
    notchedOutline: {},
    legalDisclaimerLink: {
      fontWeight: 'bold',
      textDecoration: 'none',
      color: theme.palette.grey[600],
      fontSize: theme.spacing(1.75),
      cursor: 'pointer'
    },
    popover: {
      padding: theme.spacing(1),
      maxWidth: theme.spacing(46.5),
      backgroundColor: 'white'
    },
    error: {
      fontSize: theme.spacing(2),
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.error.alt
    },
    privacyPolicy: {
      color: theme.palette.primary.main
    }
  };
};

exports.styles = styles;
var useStyles = (0, _styles.makeStyles)(styles);

var BorrowerVerifyIdentityForm = function BorrowerVerifyIdentityForm(_ref) {
  var onSuccess = _ref.onSuccess,
      client = _ref.client,
      claimToken = _ref.claimToken,
      _ref$privateLabel = _ref.privateLabel,
      privateLabel = _ref$privateLabel === void 0 ? 'valued' : _ref$privateLabel,
      _ref$isPartnerBorrowe = _ref.isPartnerBorrower,
      isPartnerBorrower = _ref$isPartnerBorrowe === void 0 ? false : _ref$isPartnerBorrowe;
  var classes = useStyles(); // Keep references to anchor element for popover

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var enterpriseOutlineOverrideProps = {
    InputLabelProps: {
      classes: {
        root: classes.label,
        focused: classes.focused
      }
    },
    InputProps: {
      classes: {
        root: classes.outlinedInput,
        focused: classes.focused,
        notchedOutline: classes.notchedOutline
      }
    }
  };

  var _useMutation = (0, _client.useMutation)(_claimAccount["default"], {
    client: client
  }),
      _useMutation2 = (0, _slicedToArray2["default"])(_useMutation, 2),
      submitClaimAccount = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      loading = _useMutation2$.loading,
      error = _useMutation2$.error;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      hasUnknownError = _useState4[0],
      setHasUnknownError = _useState4[1];

  var hasError = Boolean(error || hasUnknownError);
  return /*#__PURE__*/_react["default"].createElement(_.Grid, {
    container: true,
    item: true,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    xs: 12,
    md: 7,
    className: classes.borrowerVerifyIdentityForm
  }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_.Form, {
    initialValues: {},
    onSubmit: function onSubmit(values) {
      // First reset any errors, if present
      if (hasUnknownError) {
        setHasUnknownError(false);
      }

      submitClaimAccount({
        variables: {
          lastFourSSN: "".concat(values === null || values === void 0 ? void 0 : values.lastFourSSN),
          birthYear: "".concat(values === null || values === void 0 ? void 0 : values.birthYear),
          token: claimToken
        },
        onCompleted: function onCompleted(data) {
          var _data$submit_claim_ac;

          if (data !== null && data !== void 0 && (_data$submit_claim_ac = data.submit_claim_account) !== null && _data$submit_claim_ac !== void 0 && _data$submit_claim_ac.success) {
            onSuccess();
          } else {
            setHasUnknownError(true);
          }
        }
      });
    },
    validationSchema: _validation.claimAccountVerifyInformationSchema
  }, function (_ref2) {
    var isValid = _ref2.isValid,
        dirty = _ref2.dirty;
    return /*#__PURE__*/_react["default"].createElement(_.LoadingGate, {
      condition: !loading
    }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
      container: true
    }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
      container: true,
      item: true,
      className: classes.fieldsContainer,
      spacing: 2,
      justifyContent: "center",
      alignContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12,
      align: "left"
    }, /*#__PURE__*/_react["default"].createElement(_.Grid, {
      container: true,
      className: classes.header
    }, /*#__PURE__*/_react["default"].createElement(_.Typography, {
      variant: "h6",
      Component: "h1"
    }, _i18n.BORROWER_FLOW.SIGN_UP_HEADER)), /*#__PURE__*/_react["default"].createElement(_.Grid, {
      container: true
    }, /*#__PURE__*/_react["default"].createElement(_.Typography, null, _i18n.BORROWER_FLOW.SIGN_UP_SUB_HEADER(privateLabel))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
      container: true,
      className: classes.instructions
    }, /*#__PURE__*/_react["default"].createElement(_.Typography, null, _i18n.BORROWER_FLOW.SIGN_UP_INSTRUCTIONS))), hasError && /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_.Alert, {
      severity: "error",
      color: "error",
      variant: "standard",
      className: classes.error
    }, _i18n.BORROWER_FLOW.FORM.ERROR(isPartnerBorrower ? _constants.SUPPORT_PHONE_NUMBERS.enterprise : _constants.SUPPORT_PHONE_NUMBERS["default"]))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_.TextField, (0, _extends2["default"])({
      dataQa: "last-four-ssn",
      type: "text",
      label: _i18n.BORROWER_FLOW.FORM.LAST_FOUR_SSN,
      name: "lastFourSSN"
    }, enterpriseOutlineOverrideProps))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_.TextField, (0, _extends2["default"])({
      dataQa: "birth-year",
      type: "text",
      label: _i18n.BORROWER_FLOW.FORM.BIRTH_YEAR,
      name: "birthYear"
    }, enterpriseOutlineOverrideProps)))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12,
      align: "left"
    }, /*#__PURE__*/_react["default"].createElement(_.Typography, {
      variant: "caption"
    }, /*#__PURE__*/_react["default"].createElement(_.Link, {
      component: "button",
      dataQa: "legal-disclaimer-link",
      className: classes.legalDisclaimerLink,
      onClick: handleClick
    }, _i18n.BORROWER_FLOW.WHY_NEED_THIS_INFO)), /*#__PURE__*/_react["default"].createElement(_core.Popover, {
      open: Boolean(anchorEl),
      anchorEl: anchorEl,
      onClose: function onClose() {
        setAnchorEl(null);
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      }
    }, /*#__PURE__*/_react["default"].createElement(_.Spacing, null, /*#__PURE__*/_react["default"].createElement(_.Typography, {
      className: classes.popover
    }, _i18n.BORROWER_FLOW.WHY_NEED_INFO_EXPLANATION)))), /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12,
      align: "left"
    }, /*#__PURE__*/_react["default"].createElement(_.Typography, null, _i18n.BORROWER_FLOW.CONSENT, /*#__PURE__*/_react["default"].createElement(_.Link, {
      href: "https://earnup.com/privacy-policy/",
      component: "button",
      dataQa: "legal-consent",
      className: classes.privacyPolicy,
      target: "_blank"
    }, _i18n.BORROWER_FLOW.PRIVACY_POLICY), ".")), /*#__PURE__*/_react["default"].createElement(_.Grid, {
      item: true,
      xs: 12,
      align: "right"
    }, /*#__PURE__*/_react["default"].createElement(_.Spacing, {
      marginTop: 5
    }, /*#__PURE__*/_react["default"].createElement(_.SubmitButton, {
      color: "primary",
      dataQa: "signup-form-submit-button",
      disabled: !(isValid && dirty),
      className: !(isValid && dirty) ? classes.submitBtn : ''
    }, /*#__PURE__*/_react["default"].createElement(_.Typography, {
      dataQa: "signup-form-submit-label",
      variant: "overline"
    }, _i18n.BORROWER_FLOW.SIGN_UP_BUTTON))))));
  })));
};

BorrowerVerifyIdentityForm.propTypes = {
  onSuccess: _propTypes["default"].func.isRequired,
  claimToken: _propTypes["default"].string.isRequired,
  privateLabel: _propTypes["default"].string,
  client: _propTypes["default"].object.isRequired
};
BorrowerVerifyIdentityForm.defaultProps = {
  privateLabel: 'valued'
};
var _default = BorrowerVerifyIdentityForm;
exports["default"] = _default;